import React from 'react'; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import cropic from "../../assets/images/onboardlogo/cropic.png";
import nfsm from "../../assets/images/onboardlogo/nfsm.png";
import { Link } from "react-router-dom";
import '../../assets/styles/barhide.css';
import pmfby from "../../assets/images/onboardlogo/pmfby.png";
import nhb from "../../assets/images/onboardlogo/NHB.png";
import soilhc from "../../assets/images/onboardlogo/shc.png";
import ami from "../../assets/images/onboardlogo/ami.jpeg";
import AIF from "../../assets/images/onboardlogo/AIF.png";
import acabc from "../../assets/images/onboardlogo/acabc.png";
import SeedsDistribution from "../../assets/images/onboardlogo/SeedsDistribution.png";
import cdp from "../../assets/images/onboardlogo/cdp.png";
import pdmc from "../../assets/images/onboardlogo/pdmc.png";
function SchemeReports() {
    return (
        <>
         {/* <aside id="myDIV" className="sidebar">
            </aside> */}
          <main id="main" className="main AdminAccess">
          {/* <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
           <nav>
         <h1>MIS Reports</h1>
         <ol className="breadcrumb">
           <li className="breadcrumb-item">Admin</li>
           <li className="breadcrumb-item active">All Scheme MIS Reports</li>
         </ol>
         </nav> 
 <Link className="btn btn-success backdashbord" to="/AdminAccess"><i class="bi bi-skip-backward"></i> Back</Link>
       </div> */}
    <div className="container-fluid">

 <div className="card">
   <div className="card-body onbordedSchemess schemesreport">
   <div className="row d-flex min-vh-50 p-5 align-items-center justify-content-center">
        
   <div className="col-md-2 col-sm-4">
              <div className="dashboardcard">
              <Link to="/nfsmscheme">
                <div className="card-body"><img src={nfsm}/>
              </div>
              <h6>NFSM</h6>
              </Link>               
              </div>
            </div>
            {/* <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="">
                <div className="card-body"><img src={pdmc}/>
              </div>
              <h6>PDMC</h6>
              </Link>               
              </div>
            </div> */}
            {/* <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={pmfby}/>
              </div>
              <h6>CCE - PMFBY</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={nhb}/>
              </div>
              <h6>NHB Inspection</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={soilhc}/>
              </div>
              <h6>Soil Health Card</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={ami}/>
              </div>
              <h6>Agri Marketing Infrastructure</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={AIF}/>
              </div>
              <h6>AIF</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={SeedsDistribution}/>
              </div>
              <h6>Seed Distribution</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={acabc}/>
              </div>
              <h6>AC & ABC</h6>
              </Link>               
              </div>
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={cdp}/>
              </div>
              <h6>Cluster Development Program (CDP)</h6>
              </Link>               
              </div>
            </div>
        
            <div className="col-md-2 col-sm-4">
              <div className="card">
              <Link to="/map">
                        <div className="card-body"><img src={cropic}/>
              </div>
              <h6>CROPIC</h6>
              </Link>               
              </div>
            </div> */}
       
          </div>
   </div>
 </div>
  

 </div>
 </main>

 <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India.
            </a>
          </div>
        </footer> 

        </>

        );
    }
    
    export default SchemeReports